"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AutoAddressAutocomplete = require("./AutoAddressAutocomplete");

var _AutoAddressAutocomplete2 = _interopRequireDefault(_AutoAddressAutocomplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AutoAddressAutocomplete2.default;